import type { Size } from 'types/size';

export function mapSizes<T extends string, V extends Size>(map: Record<T, V>, size?: T): V | undefined {
    return size ? map[size] : undefined;
}
